import { computed, type ComputedRef } from 'vue'
import { useRoute } from 'vue-router'
import { FOUNDER_LETTER_ID } from '@/components/setup/FounderLetter/founder-letter'
import { useArrivalStore } from '@/stores/arrival'
import { useAuthStore } from '@/stores/auth'
import { useTourStore } from '@/stores/tour'

/** Drives the one-time founder letter: when it may open, and recording that it has been seen. */
export function useFounderLetter(): {
  open: ComputedRef<boolean>
  firstName: ComputedRef<string | undefined>
  dismiss: () => void
} {
  const route = useRoute()
  const arrival = useArrivalStore()
  const auth = useAuthStore()
  const tour = useTourStore()

  const open = computed(() => {
    if (route.name !== 'setup') return false
    if (arrival.scene === 'arrival') return false
    if (!tour.stateLoaded) return false
    return !tour.seen.has(FOUNDER_LETTER_ID)
  })

  const firstName = computed(() => auth.user?.displayName?.trim().split(/\s+/)[0])

  function dismiss(): void {
    tour.markSeen(FOUNDER_LETTER_ID)
  }

  return { open, firstName, dismiss }
}
